export default __webpack_public_path__ + "static/media/no-trading-signals-dark.612dc0a9.png";